
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InnerMenuComponent } from './inner-menu.component';

export const InnerMenuRoutes: Routes = [
    {
        path: '',
        component: InnerMenuComponent,
        children: [
            {
                path: 'sales',
                loadChildren: () => import('../inner-menu-sales/inner-menu-sales.module').then(m => m.InnerMenuSalesModule)
            },
            {
              path: 'buy',
              loadChildren: () => import('../inner-menu-buy/inner-menu-buy.module').then(m => m.InnerMenuBuyModule)
            },
            {
              path: 'liveprocess',
              loadChildren: () => import('../inner-menu-liveprocess/inner-menu-liveprocess.module').then(m => m.InnerMenuLiveProcessModule)
            },
            {
              path: 'oldprocess',
              loadChildren: () => import('../inner-menu-oldprocess/inner-menu-oldprocess.module').then(m => m.InnerMenuOldProcessModule)
            },
            {
              path: 'account',
              loadChildren: () => import('../inner-menu-account/inner-menu-account.module').then(m => m.InnerMenuAccountModule)
            },           
        ]
    },
    {
        path: '**',
        redirectTo: ''
    }
];

@NgModule({
    imports: [RouterModule.forChild(InnerMenuRoutes)],
    exports: [RouterModule],
    providers: []
})
export class InnerMenuRoutingModule { }
